<template>
  <div>
    <!-- Floating Button -->
    <b-button class="laf-fab" variant="light-danger" type="button" @click="open = !open" aria-label="Ouvrir les scripts">
      <i class="fas fa-file-alt"></i>
      <span class="d-none d-md-inline ml-2">Scripts</span>
    </b-button>

    <!-- Sidebar -->
    <b-sidebar
      id="laf-script-sidebar"
      v-model="open"
      ref="sidebar"
      right
      shadow
      backdrop
      bg-variant="white"
      :width="sidebarWidth"
      :no-header="true"
    >
      <!-- Header -->
      <div class="laf-header">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <div class="laf-icon mr-3">
              <i class="fas fa-layer-group"></i>
            </div>
            <div>
              <div class="laf-title">Scripts</div>              
            </div>
          </div>

          <button class="btn btn-sm btn-light laf-close" @click="closeSidebar" aria-label="Fermer">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <!-- Content -->
      <div class="laf-body">
        <b-tabs pills card nav-class="laf-tabs" align="center" active-nav-item-class="laf-tab-active">
          <!-- Face à Face -->
          <b-tab title="Face à Face">
            <div class="laf-pane">              
              <div class="accordion" role="tablist">
                <b-card
                  v-for="(sec, idx) in faceSections"
                  :key="sec.id"
                  class="laf-acc-card"
                  no-body
                >
                  <b-card-header class="laf-acc-header" header-tag="header" role="tab">
                    <b-button
                      block
                      variant="link"
                      class="laf-acc-btn"
                      v-b-toggle="'face-col-' + idx"
                    >
                      <span class="laf-acc-title">{{ sec.title }}</span>
                      <i class="fas fa-chevron-down laf-chevron"></i>
                    </b-button>
                  </b-card-header>

                  <b-collapse
                    :id="'face-col-' + idx"
                    accordion="face-accordion"
                    role="tabpanel"
                  >
                    <b-card-body class="laf-acc-body">
                      <div v-if="sec.subtitle" class="laf-subblock">{{ sec.subtitle }}</div>
                      <pre class="laf-pre mb-0"><code>{{ sec.body }}</code></pre>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </b-tab>

          <!-- VAD -->
          <b-tab title="VAD">
            <div class="laf-pane">
              <div class="accordion" role="tablist">
                <b-card
                  v-for="(sec, idx) in vadSections"
                  :key="sec.id"
                  class="laf-acc-card"
                  no-body
                >
                  <b-card-header class="laf-acc-header" header-tag="header" role="tab">
                    <b-button
                      block
                      variant="link"
                      class="laf-acc-btn"
                      v-b-toggle="'vad-col-' + idx"
                    >
                      <span class="laf-acc-title">{{ sec.title }}</span>
                      <i class="fas fa-chevron-down laf-chevron"></i>
                    </b-button>
                  </b-card-header>

                  <b-collapse
                    :id="'vad-col-' + idx"
                    accordion="vad-accordion"
                    role="tabpanel"
                  >
                    <b-card-body class="laf-acc-body">
                      <div v-if="sec.subtitle" class="laf-subblock">{{ sec.subtitle }}</div>
                      <pre class="laf-pre mb-0"><code>{{ sec.body }}</code></pre>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: "LafScriptsSidebar",
  data() {
    return {
      open: false,
      faceSections: [
        {
          id: "face-1",
          title: "1. Introduction et identification",
          body:
            "Bonjour,\n" +
            "Je m’appelle [Prénom Nom], je suis conseiller en assurances au sein de la société L’Assureur Français, immatriculée à l’ORIAS sous le numéro 07022530.\n\n" +
            "Vous êtes aujourd’hui en agence pour un entretien en face-à-face.\n\n" +
            "Est-ce que je parle bien avec Monsieur / Madame [Nom du client] ?",
        },
        {
          id: "face-2",
          title: "2. Objet de l’entretien – Consentement écrit",
          body:
            "L’objet de cet entretien est de vous informer et de vous conseiller sur une complémentaire santé individuelle.\n\n" +
            "Avant de commencer, je vous informe que certaines données personnelles vont être recueillies afin de réaliser une étude personnalisée de vos besoins et de vous établir un devis.\n\n" +
            "Je vais vous demander de formaliser votre accord écrit, en cochant la case prévue et en signant le document, afin d’autoriser l’étude de vos besoins, l’établissement d’un devis, ainsi que la remise et la présentation en lecture directe des documents précontractuels.\n\n" +
            "Souhaitez-vous poursuivre dans ce cadre ?",
        },
        {
          id: "face-3",
          title: "3. Recueil détaillé des besoins (FIC)",
          subtitle: "Situation générale + analyse par poste + besoins futurs + préférences",
          body:
            "Pour pouvoir vous présenter une offre réellement adaptée, je vais parcourir avec vous l’ensemble des points mentionnés dans la fiche d’information et de conseil.\n\n" +
            "Merci de répondre de la manière la plus précise possible afin que nous puissions vous conseiller correctement.\n\n" +
            "A — Votre situation générale\n\n" +
            "1. Pouvez-vous me confirmer votre âge ?\n" +
            "2. Quelle est votre situation familiale ? Personne seule, couple, famille.\n" +
            "3. Avez-vous actuellement une complémentaire santé ?\n" +
            "   Si oui, auprès de quel organisme ?\n" +
            "4. Quel est votre régime obligatoire et votre adresse ?\n" +
            "5. Êtes-vous bénéficiaire de la Complémentaire Santé Solidaire ? Oui / Non\n" +
            "6. Êtes-vous pris en charge à 100 % pour une ALD ? Oui / Non\n" +
            "7. Pratiquez-vous un sport à risque ? Oui / Non\n" +
            "8. Pour quelles raisons souhaitez-vous changer de mutuelle ?\n" +
            "   Le prix\n" +
            "   Les garanties\n" +
            "   Le rapport qualité-prix\n" +
            "   Un changement de situation\n" +
            "   Une insatisfaction générale\n" +
            "   Autre\n\n" +
            "B — Analyse de vos besoins actuels par poste\n\n" +
            "Pour chaque poste, indiquez votre niveau de besoin parmi :\n" +
            "Modéré / Fort / Très fort / Pas de besoin.\n\n" +
            "Soins courants\n" +
            "Consultations, spécialistes, analyses, radiologie, kinésithérapie, actes paramédicaux.\n\n" +
            "Hospitalisation\n" +
            "Séjour, chirurgie, chambre particulière, hospitalisation ambulatoire.\n\n" +
            "Optique\n" +
            "Monture, verres, lentilles, suivi ophtalmologique.\n\n" +
            "Dentaire – soins classiques\n" +
            "Détartrage, soins conservateurs, caries.\n\n" +
            "Prothèses dentaires et implants\n" +
            "Couronnes, bridges, implants, parodontie.\n\n" +
            "Audition\n" +
            "Appareillage auditif, accessoires, réglages.\n\n" +
            "Médecines douces et dépenses de confort\n" +
            "Ostéopathie, psychologie, naturopathie, acupuncture.\n\n" +
            "C — Besoins futurs (3 à 12 mois)\n\n" +
            "Une hospitalisation programmée est-elle prévue ? Oui / Non\n" +
            "Des soins dentaires importants sont-ils prévus ? Oui / Non\n" +
            "Une dépense optique est-elle prévue ? Oui / Non\n" +
            "Avez-vous des besoins futurs en cure thermale ? Oui / Non\n" +
            "Avez-vous des besoins futurs en médecines naturelles ? Oui / Non\n" +
            "Avez-vous des besoins futurs en appareillage auditif ? Oui / Non\n\n" +
            "D — Préférences générales\n\n" +
            "Souhaitez-vous bénéficier du dispositif 100 % Santé en optique ? Oui / Non\n" +
            "Souhaitez-vous bénéficier du dispositif 100 % Santé en dentaire ? Oui / Non\n" +
            "Souhaitez-vous bénéficier du dispositif 100 % Santé en audition ? Oui / Non\n\n" +
            "Quel type de couverture souhaitez-vous ?\n" +
            "Économique\n" +
            "Intermédiaire\n" +
            "Haut de gamme\n\n" +
            "E — Conclusion du recueil des besoins\n\n" +
            "Conformément à l’étude de vos besoins et exigences, réalisée sous notre statut de société de courtage de niveau 1, nous allons vous présenter une garantie en adéquation avec votre profil et vos attentes.\n\n" +
            "Nous passons maintenant à la présentation de l’offre.",
        },
        {
          id: "face-4",
          title: "4. Informations précontractuelles obligatoires",
          body:
            "Nous sommes un courtier en assurances : nous analysons vos besoins et recherchons pour vous la solution la plus adaptée parmi plusieurs assureurs partenaires.\n\n" +
            "Nos assureurs partenaires\n\n" +
            "Nous travaillons avec plusieurs compagnies d’assurance :\n" +
            "[Liste des assureurs partenaires]\n\n" +
            "Notre mode de rémunération\n\n" +
            "Notre cabinet est rémunéré par une commission versée par l’assureur, sans aucun frais supplémentaires pour vous.\n\n" +
            "Vos droits sur vos données personnelles\n\n" +
            "Vous disposez d’un droit d’accès, de rectification, d’opposition et de suppression de vos données personnelles.\n\n" +
            "Souhaitez-vous poursuivre ?",
        },
        {
          id: "face-5",
          title: "5. Présentation complète de l’offre",
          subtitle: "Garanties + 100% Santé + exemples + exclusions",
          body:
            "Merci pour vos réponses.\n\n" +
            "Conformément à l’étude de vos besoins et exigences, réalisée sous notre statut de société de courtage de niveau 1, nous allons vous présenter une garantie en adéquation avec votre profil et vos attentes.\n\n" +
            "La formule [Nom de la formule] de chez [Assureur] correspond à vos besoins.\n\n" +
            "5.1 Détail des garanties\n\n" +
            "Hospitalisation\n" +
            "Prise en charge jusqu’à [XXX % BRSS].\n" +
            "Chambre particulière selon les modalités prévues au contrat.\n" +
            "Frais de séjour, honoraires chirurgicaux et blocs opératoires pris en charge selon les garanties souscrites.\n" +
            "Hospitalisation ambulatoire et lit d’accompagnant selon les modalités prévues.\n\n" +
            "Soins courants\n" +
            "Médecins généralistes et spécialistes, radiologie, scanner, IRM, analyses médicales, kinésithérapie, orthophonie, actes paramédicaux et téléconsultation selon le niveau de garanties.\n\n" +
            "Dentaire\n" +
            "Soins classiques pris en charge à 100 % de la base de remboursement.\n" +
            "Prothèses dentaires, orthodontie, implants et parodontie selon les plafonds prévus.\n\n" +
            "Optique\n" +
            "Monture et verres remboursés sous forme de forfait.\n" +
            "Lentilles et chirurgie réfractive selon les modalités contractuelles.\n\n" +
            "Audition\n" +
            "Appareils auditifs, accessoires, piles et entretien selon les plafonds prévus.\n\n" +
            "Médicaments\n" +
            "Médicaments remboursés par la Sécurité sociale pris en charge selon le contrat.\n\n" +
            "Urgences et transport\n" +
            "Passage aux urgences, ambulance et VSL selon les garanties souscrites.\n\n" +
            "Maternité\n" +
            "Forfait naissance et suivi de grossesse selon les conditions prévues.\n\n" +
            "Médecines douces\n" +
            "Ostéopathie, psychologie et autres pratiques dans la limite du nombre de séances prévues.\n\n" +
            "Prévention et autres prestations\n" +
            "Vaccins, bilans de prévention, cure thermale et appareillage médical selon les modalités contractuelles.\n\n" +
            "5.2 Présentation du dispositif 100 % Santé\n\n" +
            "Le dispositif 100 % Santé permet de bénéficier de certains équipements sans aucun reste à charge, grâce à la prise en charge combinée de la Sécurité sociale et de la complémentaire santé.\n\n" +
            "Il couvre trois domaines.\n\n" +
            "Optique\n" +
            "Montures et verres du panier réglementé remboursés intégralement.\n\n" +
            "Dentaire\n" +
            "Couronnes, bridges et prothèses du panier 100 % Santé pris en charge totalement.\n\n" +
            "Audition\n" +
            "Appareils auditifs de classe 1 pris en charge à 100 %.\n\n" +
            "5.3 Exemples de prise en charge\n\n" +
            "Avant de vous transmettre les documents, je vais vous donner quelques exemples concrets afin de vous aider à mieux comprendre comment fonctionne la prise en charge selon les garanties choisies.\n\n" +
            "Ces exemples sont fournis à titre indicatif.\n\n" +
            "Les remboursements effectifs dépendent exclusivement du contrat souscrit, du tableau de garanties, des conditions générales et particulières et du respect du parcours de soins.\n\n" +
            "Seuls les documents contractuels font foi.\n\n" +
            "Consultation chez un médecin généraliste\n" +
            "Vous consultez un médecin généraliste conventionné secteur 1 dans le cadre du parcours de soins coordonné.\n" +
            "La Sécurité sociale rembourse sur la base réglementaire en vigueur.\n" +
            "La complémentaire santé intervient en complément selon la formule choisie.\n" +
            "La participation forfaitaire reste due conformément à la réglementation.\n\n" +
            "Consultation chez un médecin spécialiste\n" +
            "Vous consultez un médecin spécialiste sur prescription de votre médecin traitant.\n" +
            "La Sécurité sociale rembourse sur la base en vigueur.\n" +
            "La complémentaire santé complète le remboursement selon la formule choisie.\n" +
            "En cas de dépassements d’honoraires, un reste à charge peut subsister.\n\n" +
            "Hospitalisation\n" +
            "Vous êtes hospitalisé pour une intervention chirurgicale programmée.\n" +
            "Les frais de séjour et honoraires médicaux sont pris en charge selon les bases de remboursement applicables.\n" +
            "Le forfait journalier hospitalier et la chambre particulière sont pris en charge uniquement s’ils sont prévus au contrat.\n\n" +
            "Soins dentaires\n" +
            "Si l’acte est éligible au dispositif 100 % Santé, il n’y a aucun reste à charge.\n" +
            "Hors panier 100 % Santé, la prise en charge dépend du niveau de garantie souscrit.\n\n" +
            "Optique\n" +
            "Le panier 100 % Santé permet une prise en charge intégrale.\n" +
            "En dehors de ce panier, le remboursement s’effectue sous forme de forfait.\n\n" +
            "Médecines douces\n" +
            "La Sécurité sociale n’intervient pas.\n" +
            "La prise en charge dépend des plafonds prévus au contrat.\n\n" +
            "5.4 Exemples de remboursements\n\n" +
            "Consultation spécialiste 60 euros.\n" +
            "Base de remboursement 30 euros.\n" +
            "Formule 200 %.\n" +
            "Remboursement 60 euros.\n\n" +
            "Couronne hors 100 % Santé 550 euros.\n" +
            "Base de remboursement 120 euros.\n" +
            "Formule 300 %.\n" +
            "Remboursement 360 euros.\n\n" +
            "Lunettes 100 % Santé.\n" +
            "Reste à charge zéro.\n\n" +
            "5.5 Exclusions et limitations\n\n" +
            "Certains actes non remboursés par la Sécurité sociale, notamment les actes à visée esthétique, ne sont pas pris en charge.\n" +
            "Les dépassements d’honoraires hors dispositifs de pratique tarifaire maîtrisée peuvent entraîner un reste à charge.\n" +
            "Les établissements non conventionnés peuvent ne pas être pris en charge.\n" +
            "Des délais d’attente peuvent s’appliquer selon les prestations.\n" +
            "Des plafonds annuels peuvent s’appliquer sur certaines garanties, notamment les médecines douces, la psychologie et l’optique hors panier réglementé.",
        },
        {
          id: "face-6",
          title: "6. Remise des documents précontractuels",
          body:
            "Les documents suivants vous sont remis ou présentés en lecture directe :\n" +
            "la fiche d’information et de conseil,\n" +
            "les conditions générales,\n" +
            "le tableau de garanties,\n" +
            "la notice d’information,\n" +
            "les modalités de résiliation,\n" +
            "les exemples de remboursement,\n" +
            "le bulletin individuel d’adhésion.",
        },
        {
          id: "face-7",
          title: "7. Conclusion et droit de rétractation",
          body:
            "Si vous décidez de souscrire, vous bénéficiez d’un droit de rétractation de 14 jours à compter de la signature.\n\n" +
            "Souhaitez-vous procéder à la souscription aujourd’hui ou préférez-vous repartir avec l’ensemble des documents pour étude ?",
        },
      ],

      vadSections: [
        {
          id: "vad-1",
          title: "1. Introduction & identification",
          body:
            "Bonjour, je m’appelle [Prénom Nom], je vous appelle de la société L’Assureur Français, immatriculée à l’ORIAS sous le numéro 07022530.\n\n" +
            "Vous nous avez donné votre consentement explicite sur notre site internet pour être contacté, en cochant la case opt-in de consentement de notre appel.\n\n" +
            "Est-ce que je parle bien avec Monsieur/Madame [Nom du prospect] ?\n\n" +
            "Avant de commencer, je vous rappelle que cet appel est  enregistré pour des raisons de controle qualite et de conformite selon la reglementation"
        },
        {
          id: "vad-2",
          title: "2. Objet de l’appel – Rappel du consentement",
          body:
            "Suite à votre demande pour recevoir un devis de complémentaire santé, je vous appelle pour :\n\n" +
            "• vérifier vos besoins via la fiche d’information clé (FIC),\n" +
            "• vous présenter une solution adaptée,\n" +
            "• et vous transmettre un devis personnalisé.\n\n" +
            "Souhaitez-vous poursuivre ?",
        },
        {
          id: "vad-3",
          title: "3. Recueil détaillé des besoins (basé sur notre FIC)",
          subtitle: "Situation générale + analyse par poste + besoins futurs + préférences",
          body:
            "Pour pouvoir vous présenter une offre réellement adaptée, je vais parcourir avec vous l’ensemble des points mentionnés dans la fiche d’information et de conseil (FIC) .\n" +
            "Merci de répondre de la manière la plus précise possible afin que nous puissions vous conseiller correctement.\n\n" +
            "A — Votre situation générale\n\n" +
            "1 Pouvez-vous me confirmer votre âge ?\n" +
            "2 Quelle est votre situation familiale ? (Personne seule, couple, famille…)\n" +
            "3 Avez-vous actuellement une complémentaire santé ?\n" +
            "◦ Si oui, auprès de quel organisme ?\n" +
            "4 votre regime obligatoire  et votre adresse ?\n" +
            "5 Êtes-vous bénéficiaire de la CSS (Complémentaire Santé Solidaire) ? Oui / Non\n" +
            "6 Êtes-vous à 100 % pour une ALD ? Oui / Non\n" +
            "7 Pratiquez-vous un sport à risque ? Oui / Non\n" +
            "8 Pour quelles raisons souhaitez-vous changer de mutuelle ?\n" +
            "◦ Le prix\n" +
            "◦ Les garanties\n" +
            "◦ Le rapport qualité-prix\n" +
            "◦ Un changement de situation\n" +
            "◦ Une insatisfaction générale\n" +
            "◦ Autre (à préciser)\n\n" +
            "B — Analyse de vos besoins actuels par poste\n\n" +
            "Pour chaque poste, indiquez votre niveau de besoin parmi :\n" +
            "➡ Modéré / Fort / Très fort / Pas de besoin\n\n" +
            "1. Soins courants\n\n" +
            "Consultations, spécialistes, analyses, radiologie, kinésithérapie, actes paramédicaux.\n" +
            "➡ Modéré / Fort / Très fort / Pas de besoin\n\n" +
            "2. Hospitalisation\n\n" +
            "Séjour, chirurgie, chambre particulière, hospitalisation ambulatoire.\n" +
            "➡ Modéré / Fort / Très fort / Pas de besoin\n\n" +
            "3. Optique\n\n" +
            "Monture, verres, lentilles, suivi ophtalmologique.\n" +
            "➡ Modéré / Fort / Très fort / Pas de besoin\n\n" +
            "4. Dentaire (soins classiques)\n\n" +
            "Détartrage, soins conservateurs, caries.\n" +
            "➡ Modéré / Fort / Très fort / Pas de besoin\n\n" +
            "5. Prothèses dentaires / implants\n\n" +
            "Couronnes, bridges, implants, parodontie.\n" +
            "➡ Modéré / Fort / Très fort / Pas de besoin\n\n" +
            "6. Audition\n\n" +
            "Appareillage auditif, accessoires, réglages.\n" +
            "➡ Modéré / Fort / Très fort / Pas de besoin\n\n" +
            "7. Médecines douces & dépenses de confort\n\n" +
            "Ostéopathie, psychologie, naturopathie, acupuncture…\n" +
            "➡ Modéré / Fort / Très fort / Pas de besoin\n\n" +
            "C — Besoins futurs (3 à 12 mois)\n\n" +
            "1 Une hospitalisation programmée est-elle prévue ? Oui / Non\n" +
            "2 Des soins dentaires importants sont-ils prévus ? Oui / Non\n" +
            "3 Une dépense optique (lunettes, lentilles) est-elle prévue ? Oui / Non\n" +
            "4 Avez-vous des besoins futurs en :\n" +
            "◦ Cure thermale ? Oui / Non\n" +
            "◦ Médecines naturelles ? Oui / Non\n" +
            "◦ Appareillage auditif ? Oui / Non\n\n" +
            "D — Préférences générales\n\n" +
            "1 Souhaitez-vous bénéficier du dispositif 100 % Santé (le 100% santé est un dispositif qui permet d'obtenir certains equipements en optique ,dentaire et auditif sans aucun reste à charge grace au remboursement integral de la securite sociale et de la complementaire santé )\n" +
            "◦ L’optique : Oui / Non\n" +
            "◦ Le dentaire : Oui / Non\n" +
            "◦ L’audition : Oui / Non\n" +
            "2\n" +
            "3 Quel type de couverture souhaitez-vous ?\n" +
            "◦ Économique\n" +
            "◦ Intermédiaire\n" +
            "◦ Haut de gamme\n\n" +
            "E — Conclusion du recueil des besoins\n\n" +
            "Conformément à l’étude de vos besoins et exigences, réalisée sous notre statut de société de courtage de niveau 1, nous allons vous présenter une garantie en adéquation avec votre profil et vos attentes.\n\n" +
            "Nous passons maintenant à la présentation de l’offre.",
        },
        {
          id: "vad-4",
          title: "4. Informations précontractuelles obligatoires",
          body:
            "Avant de vous présenter un devis, je dois vous communiquer plusieurs informations obligatoires :\n\n" +
            "• Notre rôle\n\n" +
            "Nous sommes un courtier en assurances : nous analysons vos besoins et recherchons pour vous la solution la plus adaptée parmi plusieurs assureurs partenaires.\n\n" +
            "• Nos assureurs partenaires\n\n" +
            "Nous travaillons avec plusieurs compagnies d’assurance :\n" +
            "➡ [Liste des assureurs partenaires]\n\n" +
            "• Notre mode de rémunération\n\n" +
            "Notre cabinet est rémunéré par une commission versée par l’assureur, sans aucun frais supplémentaires pour vous.\n\n" +
            "• Vos droits sur vos données personnelles (RGPD)\n\n" +
            "Vous disposez d’un droit :\n\n" +
            "• d’accès,\n" +
            "• de rectification,\n" +
            "• d’opposition,\n" +
            "• et de suppression de vos données personnelles.\n\n" +
            "Souhaitez-vous poursuivre ?",
        },
        {
          id: "vad-5",
          title: "5. Présentation complète de l’offre (conclusion du recueil des besoins)",
          subtitle: "Garanties + 100% Santé + exemples + exclusions",
          body:
            "Merci pour vos réponses.\n\n" +
            "Conformément à l’étude de vos besoins et exigences, réalisée sous notre statut de société de courtage de niveau 1, nous allons vous présenter une garantie en adéquation avec votre profil et vos attentes.\n" +
            "la formule [Nom de la formule] de chez [Assureur X] correspond à vos besoins.\n" +
            "Nous passons maintenant à la présentation de l’offre.\n\n" +
            "5.1 Détail des garanties\n\n" +
            "Hospitalisation\n\n" +
            "• Prise en charge jusqu’à [XXX % BRSS]\n" +
            "• Chambre particulière : [modalité]\n" +
            "• Frais de séjour, honoraires chirurgicaux, blocs opératoires : [modalité]\n" +
            "• Hospitalisation ambulatoire : [modalité]\n" +
            "• Lit d’accompagnant : [modalité]\n\n" +
            "Soins courants\n\n" +
            "• Médecins généralistes & spécialistes : [XX % / forfait]\n" +
            "• Radiologie, scanner, IRM : [modalité]\n" +
            "• Analyses médicales : [modalité]\n" +
            "• Kinésithérapie, orthophonie, actes paramédicaux : [modalité]\n" +
            "• Téléconsultation : [modalité]\n\n" +
            "Dentaire\n\n" +
            "• Soins classiques : 100 % BRSS\n" +
            "• Prothèses dentaires : jusqu’à [XXX €]\n" +
            "• Orthodontie : [modalité]\n" +
            "• Implants / parodontie : [modalité]\n\n" +
            "Optique\n\n" +
            "• Monture + verres : [forfait XXX €]\n" +
            "• Lentilles : [modalité]\n" +
            "• Chirurgie réfractive : [modalité]\n\n" +
            "Audition\n\n" +
            "• Appareils auditifs : jusqu’à [XXX €]\n" +
            "• Accessoires, piles, entretien : [modalité]\n\n" +
            "Médicaments\n\n" +
            "• Médicaments remboursés : [modalité]\n" +
            "• Médicaments non remboursés : [modalité ou exclusions]\n\n" +
            "Urgences & transport\n\n" +
            "• Passage aux urgences : [modalité]\n" +
            "• Ambulance / VSL : [modalité]\n\n" +
            "Maternité\n\n" +
            "• Forfait naissance : [XXX €]\n" +
            "• Suivi grossesse : [modalité]\n\n" +
            "Médecines douces\n\n" +
            "• Ostéopathie : X séances/an\n" +
            "• Psychologie : X séances/an\n" +
            "• Autres pratiques : [modalité]\n\n" +
            "Prévention\n\n" +
            "• Vaccins : [modalité]\n" +
            "• Bilans de prévention : [modalité]\n\n" +
            "Autres prestations\n\n" +
            "• Cure thermale : [modalité]\n" +
            "• Appareillage médical et orthèses : [modalité]\n\n" +
            "5.2 – Présentation du dispositif 100 % Santé\n\n" +
            "Le dispositif 100 % Santé permet de bénéficier de certains équipements sans aucun reste à charge, grâce à la prise en charge combinée de la Sécurité Sociale et de la complémentaire santé.\n\n" +
            "Il couvre trois domaines :\n\n" +
            "• Optique\n\n" +
            "Montures + verres du panier réglementé → remboursés intégralement\n\n" +
            "• Dentaire\n\n" +
            "Couronnes, bridges et prothèses du panier → prise en charge totale\n\n" +
            "• Audition\n\n" +
            "Appareils auditifs de classe 1 → 100 % pris en charge\n\n" +
            "5.3 – Exemples de prise en charge (à titre illustratif et non contractuel)\n\n" +
            "Avant de vous transmettre les documents, je vais vous donner quelques exemples concrets, afin de vous aider à mieux comprendre comment fonctionne la prise en charge, selon les garanties choisies.\n\n" +
            "Ces exemples sont fournis à titre indicatif.\n" +
            "Les remboursements effectifs dépendent exclusivement du contrat souscrit, du tableau de garanties, des conditions générales et particulières, et du respect du parcours de soins.\n" +
            "Seuls les documents contractuels font foi.\n\n" +
            "Exemple 1 — Consultation chez un médecin généraliste\n\n" +
            "Vous consultez un médecin généraliste conventionné secteur 1 dans le cadre du parcours de soins coordonné.\n\n" +
            "La Sécurité sociale rembourse sur la base réglementaire en vigueur.\n" +
            "La complémentaire santé intervient en complément, selon la formule choisie.\n" +
            "Selon le niveau de garantie, le reste à charge peut être nul ou limité.\n\n" +
            "La participation forfaitaire reste due, conformément à la réglementation.\n\n" +
            "Exemple 2 — Consultation chez un médecin spécialiste\n\n" +
            "Vous consultez un médecin spécialiste (cardiologue, dermatologue…) sur prescription de votre médecin traitant.\n\n" +
            "La Sécurité sociale rembourse sur la base en vigueur.\n" +
            "La complémentaire santé complète le remboursement selon la formule choisie.\n\n" +
            "En cas de dépassements d’honoraires, la prise en charge dépend du niveau de garanties souscrit, et un reste à charge peut subsister.\n\n" +
            "Exemple 3 — Hospitalisation médicale ou chirurgicale\n\n" +
            "Vous êtes hospitalisé pour une intervention chirurgicale programmée.\n\n" +
            "Les frais de séjour et les honoraires médicaux sont pris en charge selon les bases de remboursement applicables.\n" +
            "La complémentaire santé intervient en complément.\n\n" +
            "Le forfait journalier hospitalier peut être pris en charge selon le contrat.\n" +
            "La chambre particulière est prise en charge uniquement si elle est prévue dans les garanties souscrites.\n\n" +
            "Exemple 4 — Soins dentaires (prothèses)\n\n" +
            "Vous réalisez la pose d’une couronne dentaire.\n\n" +
            "Si l’acte est éligible au dispositif 100 % Santé, il n’y a aucun reste à charge.\n" +
            "Hors panier 100 % Santé, la Sécurité sociale rembourse sur la base réglementaire, et la complémentaire santé intervient selon le niveau de garantie.\n\n" +
            "Le reste à charge dépend du type de prothèse et de la formule souscrite.\n\n" +
            "Exemple 5 — Optique (lunettes)\n\n" +
            "Vous renouvelez vos lunettes (monture et verres).\n\n" +
            "Vous pouvez bénéficier du panier 100 % Santé, permettant une prise en charge intégrale.\n" +
            "En dehors de ce panier, le remboursement se fait sous forme de forfait, selon la formule souscrite.\n\n" +
            "Le reste à charge dépend du prix réel de l’équipement sélectionné et du niveau de garanties.\n\n" +
            "Les fréquences de renouvellement sont encadrées par la réglementation.\n\n" +
            "Exemple 6 — Médecines douces\n\n" +
            "Vous consultez un ostéopathe ou un psychologue non conventionné.\n\n" +
            "La Sécurité sociale n’intervient pas sur ce type de consultation.\n" +
            "Certaines formules prévoient un forfait annuel ou un remboursement par séance.\n\n" +
            "Le nombre de séances est plafonné selon les garanties prévues au contrat.\n\n" +
            "5.4 – Exemples de remboursements\n\n" +
            "Consultation spécialiste – 60 €\n\n" +
            "BRSS : 30 € — Formule 200 %\n" +
            "➡ Remise : 60 €\n\n" +
            "Couronne hors 100 % Santé – 550 €\n\n" +
            "BRSS : 120 € — Formule 300 %\n" +
            "➡ Remboursement : 360 €\n\n" +
            "Lunettes 100 % Santé\n\n" +
            "➡ Reste à charge : 0 €\n\n" +
            "5.4 – Exclusions et limitations\n\n" +
            "Quelques exemples d’exclusions ou limites :\n\n" +
            "• Certains actes non remboursés par la Sécurité Sociale (ex. esthétique)\n" +
            "• Dépassements d’honoraires illimités hors OPTAM\n" +
            "• Hôpitaux non conventionnés\n" +
            "• Délais d’attente selon les prestations\n" +
            "• Plafonds sur médecines douces, psychologie, optique hors panier réglementé",
        },
        {
          id: "vad-6",
          title: "6. Transmission des documents précontractuels",
          body:
            "Est-ce que les informations que je viens de vous présenter sont claires pour vous ?\n\n" +
            "Souhaitez-vous que je vous envoie immédiatement l’ensemble des documents précontractuels obligatoires, à savoir :\n\n" +
            "• la FIC / IPID,\n" +
            "• les conditions générales,\n" +
            "• le tableau des garanties,\n" +
            "• la notice d’information,\n" +
            "• les modalités de résiliation,\n" +
            "• les exemples de remboursement,\n" +
            "• et le BIA (Bulletin Individuel d’Adhésion) ?\n\n" +
            "Je peux vous les transmettre maintenant par email.",
        },
        {
          id: "vad-7",
          title: "7. Conclusion & droit de rétractation",
          body:
            "Si vous décidez de souscrire, vous bénéficierez d’un droit de rétractation de 14 jours à compter de la signature.\n\n" +
            "Souhaitez-vous que je vous envoie le devis et l’ensemble des documents pour étude ?",
        },
      ],
    };
  },
  computed: {
    sidebarWidth() {
      return "600px";
    },
  },
  methods: {
    openSidebar() {
      const ref = this.$refs.sidebar;
      if (ref && typeof ref.show === "function") ref.show();
    },
    closeSidebar() {
      const ref = this.$refs.sidebar;
      if (ref && typeof ref.hide === "function") ref.hide();
    },
  },
};
</script>

<style scoped>
/* Floating action button */
.laf-fab {
  position: fixed;
  bottom: 90px;
  right: 24px;
  z-index: 2000;
  border: 0;
  border-radius: 999px;
  padding: 12px 14px;  
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.22);
}
.laf-fab:hover {
  transform: translateY(-2px);
}
.laf-fab:active {
  transform: translateY(0);
}

/* Sidebar layout */
.laf-header {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.laf-body {
  padding: 12px;
}

.laf-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: rgba(17, 24, 39, 0.06);
  color: #111827;
  display: flex;
  align-items: center;
  justify-content: center;
}
.laf-title {
  font-size: 16px;
  font-weight: 800;
  color: #111827;
  line-height: 1.2;
}
.laf-subtitle {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}
.laf-close {
  border-radius: 10px;
}

/* Tabs */
.laf-tabs {
  border: 0 !important;
}
.laf-tabs :deep(.nav-link) {
  border-radius: 12px !important;
  font-weight: 700;
}
.laf-tab-active {
  background: rgba(17, 24, 39, 0.08) !important;
  color: #111827 !important;
}

/* Pane head */
.laf-pane-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 10px 6px 6px 6px;
  gap: 10px;
}
.laf-pane-title {
  font-weight: 800;
  color: #111827;
}
.laf-chip {
  font-size: 11px;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.04);
  color: #374151;
  white-space: nowrap;
}

/* Accordion cards */
.laf-acc-card {
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 10px;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.06);
}
.laf-acc-header {
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  padding: 0;
}
.laf-acc-btn {
  text-decoration: none !important;
  padding: 14px 14px;
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  color: #111827 !important;
  font-weight: 800;
}
.laf-acc-title {
  font-size: 13px;
  text-align: left;
}
.laf-chevron {
  opacity: 0.6;
  font-size: 12px;
}
.laf-acc-body {
  padding: 14px;
}

/* Text blocks */
.laf-subblock {
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
  margin-bottom: 10px;
}
.laf-pre {
  white-space: pre-wrap;
  word-break: break-word;
  /*background: #0b1220;
  color: #e5e7eb;*/
  border-radius: 12px;
  padding: 12px;
  font-size: 12px;
  line-height: 1.45;
}
pre code {
  background-color: white;
}
#laf-script-sidebar .card-body {
  padding: 0px;
}
</style>
<style>
.laf-body .card-header:first-of-type {
  padding: 0.5rem !important;
}
</style>
